module.exports = __webpack_public_path__ + "img/location.29297a8.png";